import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Coupon } from '../models/accounting/coupon';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private http: HttpClient) { }

  public getCouponsForUserAtHorseShow(horse_show_id: string): Promise<Coupon[]> {
         return new Promise((resolve, reject) => {
        return this.http.get(AppSettings.API_ENDPOINT + 'accounting/coupons/get_for_user/horse_show_id/' + horse_show_id).subscribe((response:any) => {
          if(response.type == 'coupons' && response.data){
            resolve(response.data);
          } else {
            reject(response);
          }

        },
          error => {
                if(error instanceof HttpErrorResponse){
                      reject(error.error);
                  } else {
                    reject(error);
                  }
          });
      });
    }

    public submitCoupon_code(code: string): Promise<Coupon> {
      let post_data = {
        data: {
          type: 'coupon_code_claim_request',
          attributes: { coupon_code: code }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'accounting/coupons/submit_coupon',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='coupon') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });
    }

}
